import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { PageResponse } from '@core/entities/pagination'
import {
  competencyTemplateKeys,
  RequestTypes,
} from '@core/react-query/features/templates/competencyTemplates'
import {
  CompetencyTemplate,
  ICompetencyTemplate,
} from '@core/entities/competency/CompetencyTemplate'
import { RequestErrorType } from '@core/utils/api-axios-instance'

const dataTransformer = (response: PageResponse<ICompetencyTemplate>) => ({
  ...response,
  content: response.content.map((template) => CompetencyTemplate.new(template)),
})

export const useGetCompetencyTemplates = (
  params: RequestTypes['getCompetencyTemplates'],
  options: UseQueryOptions<
    PageResponse<ICompetencyTemplate>,
    RequestErrorType,
    PageResponse<CompetencyTemplate>
  > = {},
) => {
  return useQuery<
    PageResponse<ICompetencyTemplate>,
    RequestErrorType,
    PageResponse<CompetencyTemplate>
  >({
    select: dataTransformer,
    ...competencyTemplateKeys.getTemplates(params),
    ...options,
  })
}
